import { render, staticRenderFns } from "./excelText.vue?vue&type=template&id=5f3e24da&scoped=true"
import script from "./excelText.vue?vue&type=script&lang=js"
export * from "./excelText.vue?vue&type=script&lang=js"
import style0 from "./excelText.vue?vue&type=style&index=0&id=5f3e24da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e24da",
  null
  
)

export default component.exports